export function Crosss() {
	return (
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2 2L28 28" stroke="currentColor" strokeWidth="4" />
			<path d="M28 2L2 28" stroke="currentColor" strokeWidth="4" />
		</svg>
	)
}
